/**
 * Types of activity subjects.
 * @enum {string}
 */
export const activitySubjectType = {
  PROJECT: 'project',
  TASK: 'task',
};

/**
 * Types of activity actions.
 * @enum {string}
 */
export const activityActionType = {
  ADD: 'added a new ',
  COMMENT: 'commented on a ',
  COMPLETE: 'completed '
};



// WEBPACK FOOTER //
// ./src/dataTypes.js